import Vue from 'vue';
import axios from 'axios';

const uiDateFormat = 'DD/MM/YYYY';


export default {
  name: 'CmrContrPnlEditReading_MessagesAndDetails',
  components: {
  },
  props: {
    editingOptions: {
      type: Object,
      required: true
    },
    descrepancyNoAccess: {
      type: Array,
      required: true
    },
    descrepancyMrNote: {
      type: Array,
      required: true
    },
    meterSizes: {
      type: Array,
      required: true
    },
    meterMakes: {
      type: Array,
      required: true
    },
    meterLocations: {
      type: Array,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    },
    editingReading: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      mrMsgCode: null,
      accessCode: null,
      meterMake: null,
      meterSize: null,
      meterLocation: null,
    }
  },
  computed: {
    isDisabled: function () {
      return this.disabled === true ? 'disabled-backgournd' : ''
    }
  },
  watch: {
    accessCode: function (val) {
      if (!val)
        this.editingReading.accessCodeId = -1;
      else
        this.editingReading.accessCodeId = val.id;
    },
    mrMsgCode: function (val) {
      if (!val)
        this.editingReading.mrMsgCodeId = -1;
      else
        this.editingReading.mrMsgCodeId = val.id;
    },
    meterSize: function (val) {
      if (!val)
        this.editingReading.meterSizeId = '';
      else
        this.editingReading.meterSizeId = val.id;
    },
    meterMake: function (val) {
      if (!val)
        this.editingReading.meterMakeId = '';
      else
        this.editingReading.meterMakeId = val.id;
    },
    meterLocation: function (val) {
      if (!val)
        this.editingReading.meterLocationId = '';
      else
        this.editingReading.meterLocationId = val.id;
    },
},
  mounted() {
    this.init();
  },
  created() {},
  methods: {
    init() {
      //default value to dropdowns
      let temp;
      if (this.editingReading.accessCodeId != null)
        temp = this.descrepancyNoAccess.filter(d => d.id == this.editingReading.accessCodeId)[0];
      else
        temp = this.descrepancyNoAccess[0];

      this.accessCode = temp;

      if (this.editingReading.mrMsgCodeId != null)
        temp = this.descrepancyMrNote.filter(d => d.id == this.editingReading.mrMsgCodeId)[0];
      else
        temp = this.descrepancyMrNote[0];

      this.mrMsgCode = temp;


      if (this.editingReading.meterMakeId != null)
        temp = this.meterMakes.filter(d => d.id == this.editingReading.meterMakeId)[0];
      else
        temp = this.meterMakes[0];

      this.meterMake = temp;

      if (this.editingReading.mrMsgCodeId != null)
        temp = this.meterSizes.filter(d => d.id == this.editingReading.meterSizeId)[0];
      else
        temp = this.meterSizes[0];

      this.meterSize = temp;

      if (this.editingReading.meterLocationId != null)
        temp = this.meterSizes.filter(d => d.id == this.editingReading.meterLocationId)[0];
      else
        temp = this.meterLocations[0];

      this.meterLocation = temp;
    },
  }
}
